import api from '../utils/api';
export const login = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `auth/login`,
        method: "POST",
        data,
        ...options,
    });
}

export const addUser = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `auth/add-user`,
        method: "POST",
        data,
        ...options,
    });
}

export const refreshToken = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `auth/refresh-token`,
        method: "POST",
        data,
        ...options,
    });
}


